<template>
    <div class="pickgirl-page">
        <van-nav-bar class="nav-bar" :title="$t('foorter.pickgirl')" />

        <div class="profile-scroll">
            <div
                class="profile-card"
                v-for="item in xuanfeilist"
                :key="item.id"
                @click="profile(item.id)"
            >
                <div class="cover-area">
                    <img
                        v-if="getImage(item)"
                        class="cover-img"
                        :src="getImage(item)"
                        @error="onImageError(item)"
                    />
                    <div class="live-badge">资料</div>
                </div>

                <div class="info-area">
                    <div class="name-row">
                        <div class="name-text">{{ item.xuanfei_name }}</div>
                        <van-icon name="arrow" color="#d9c9ef" />
                    </div>

                    <div class="meta-row" v-if="item.address">
                        <van-icon name="location-o" color="#ffb54a" />
                        <span>{{ item.address }}</span>
                    </div>

                    <div class="meta-row" v-if="item.money">
                        <van-icon name="shield-o" color="#63d7a3" />
                        <span>已缴纳 {{ item.money }} 元保证金</span>
                    </div>

                    <div class="sign-text" v-if="item.sign">签名：{{ item.sign }}</div>

                    <div class="tags" v-if="formatTags(item.label).length">
                        <span
                            v-for="(tag, index) in formatTags(item.label)"
                            :key="index"
                            :class="'tag-color-' + (index % 6)"
                            :style="tagStyle(index)"
                        >{{ tag }}</span>
                    </div>
                </div>
            </div>

            <van-empty v-if="!xuanfeilist.length" description="暂无资料" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            xuanfeilist: []
        };
    },
    methods: {
        profile(id) {
            this.$router.push({ name: 'profile', query: { id } });
        },
        getImage(item) {
            return item.show_img || item.img_url2 || item.img_url;
        },
        onImageError(item) {
            if (item.show_img === item.img_url || !item.img_url) {
                return;
            }
            this.$set(item, 'show_img', item.img_url);
        },
        formatTags(tags) {
            if (Array.isArray(tags)) {
                return tags.filter(Boolean);
            }
            if (!tags) {
                return [];
            }
            if (typeof tags === 'string') {
                try {
                    const parsedTags = JSON.parse(tags);
                    if (Array.isArray(parsedTags)) {
                        return parsedTags.filter(Boolean);
                    }
                } catch (e) {
                    return this.splitTags(tags);
                }
                return this.splitTags(tags);
            }
            return [];
        },
        splitTags(tags) {
            return tags
                .replace(/\uFF0C|\u3001|\u3002/g, ',')
                .split(/[,.|/\s]+/)
                .map(tag => tag.trim())
                .filter(Boolean);
        },
        tagStyle(index) {
            const colors = ['#e9476a', '#2dabd2', '#dea52b', '#8b63d9', '#24b47e', '#f06f3c'];
            return {
                backgroundColor: colors[index % colors.length]
            };
        },
        getxuanfeilist() {
            this.$http({
                method: 'get',
                url: 'xuanfeilist',
                data: { id: this.$route.query.id }
            }).then(res => {
                this.xuanfeilist = res.data || [];
            });
        }
    },
    created() {
        this.getxuanfeilist();
    }
};
</script>

<style lang="less" scoped>
.pickgirl-page {
    min-height: 100vh;
    background: #29243d;
    padding-bottom: 130px;
}

.profile-scroll {
    height: calc(100vh - 46px);
    overflow-y: auto;
    padding: 14px 12px 130px;
    box-sizing: border-box;
}

.profile-card {
    display: flex;
    gap: 12px;
    min-height: 214px;
    margin-bottom: 14px;
    padding: 12px;
    border-radius: 8px;
    background: #4f3460;
    box-sizing: border-box;
}

.cover-area {
    position: relative;
    flex: 0 0 43%;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background: transparent;
    overflow: hidden;
}

.cover-img {
    display: block;
    width: 100%;
    height: 202px;
    object-fit: cover;
    border-radius: 8px;
    border: none;
    outline: none;
    background: transparent;
}

.live-badge {
    position: absolute;
    left: 8px;
    top: 8px;
    padding: 3px 8px;
    border-radius: 999px;
    background: rgba(41, 36, 61, .82);
    color: #fff;
    font-size: 20px;
}

.info-area {
    flex: 1;
    min-width: 0;
    color: #fff;
}

.name-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 8px;
}

.name-text {
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 30px;
    font-weight: 600;
}

.meta-row {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 6px;
    color: #eee7f7;
    font-size: 22px;
    line-height: 1.35;
}

.meta-row span {
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.sign-text {
    margin-top: 8px;
    color: #f4edf8;
    font-size: 22px;
    line-height: 1.35;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 10px;
}

.tags span {
    max-width: 100%;
    padding: 7px 13px;
    border-radius: 999px;
    color: #fff;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.2;
}

.tag-color-0 {
    background: #e9476a;
}

.tag-color-1 {
    background: #2dabd2;
}

.tag-color-2 {
    background: #dea52b;
}

.tag-color-3 {
    background: #8b63d9;
}

.tag-color-4 {
    background: #24b47e;
}

.tag-color-5 {
    background: #f06f3c;
}

::v-deep .van-empty__description {
    color: #d9c9ef;
}
</style>
